import React, { useState, useEffect } from 'react';
import client from '../api/client';
import { Card, Spin, Empty, Button, Modal, Input, message, Pagination } from 'antd';
import styles from './Blog.module.css';

const API_BASE = '/blog';

export default function BlogManager() {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [selectedBlog, setSelectedBlog] = useState(null);
  const [adminNotes, setAdminNotes] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [action, setAction] = useState(null);
  const limit = 10;

  useEffect(() => {
    loadPendingBlogs();
  }, [page]);

  const loadPendingBlogs = async () => {
    setLoading(true);
    try {
      const res = await client.get(`${API_BASE}/admin/pending`, {
        params: { page, limit }
      });
      setBlogs(res.data.blogs || []);
      setTotal(res.data.total || 0);
    } catch (err) {
      message.error('خطا در بارگذاری مقالات');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = (blog) => {
    setSelectedBlog(blog);
    setAction('approve');
    setAdminNotes('');
    setShowModal(true);
  };

  const handleReject = (blog) => {
    setSelectedBlog(blog);
    setAction('reject');
    setAdminNotes('');
    setShowModal(true);
  };

  const submitAction = async () => {
    if (!selectedBlog) return;

    try {
      if (action === 'approve') {
        await client.patch(`${API_BASE}/${selectedBlog._id}/approve`, {
          adminNotes
        });
        message.success('مقاله تایید شد.');
      } else if (action === 'reject') {
        if (!adminNotes.trim()) {
          message.error('توضیحات رد کردن الزامی است.');
          return;
        }
        await client.patch(`${API_BASE}/${selectedBlog._id}/reject`, {
          adminNotes: adminNotes.trim()
        });
        message.success('مقاله رد شد.');
      }
      setShowModal(false);
      setSelectedBlog(null);
      loadPendingBlogs();
    } catch (err) {
      message.error(err.response?.data?.message || 'خطا در عملیات');
    }
  };

  return (
    <div className={styles.adminPanel}>
      <h2>مدیریت مقالات ({total} در انتظار تایید)</h2>
      <Spin spinning={loading}>
        {blogs.length === 0 ? (
          <Empty description="هیچ مقاله‌ای برای تایید وجود ندارد." />
        ) : (
          <>
            <div className={styles.pendingBlogs}>
              {blogs.map((blog) => (
                <Card key={blog._id} className={styles.pendingCard}>
                  <h3>{blog.title}</h3>
                  <p style={{ fontSize: '12px', color: '#666' }}>
                    نویسنده: {blog.author?.firstName} {blog.author?.lastName}
                  </p>
                  <p style={{ fontSize: '12px', color: '#666' }}>
                    تاریخ: {new Date(blog.createdAt).toLocaleDateString('fa-IR')}
                  </p>
                  <p style={{ margin: '12px 0', color: '#555' }}>
                    {blog.content.substring(0, 300)}...
                  </p>
                  <div className={styles.blogActions}>
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => handleApprove(blog)}
                    >
                      تایید
                    </Button>
                    <Button
                      danger
                      size="small"
                      onClick={() => handleReject(blog)}
                    >
                      رد کردن
                    </Button>
                  </div>
                </Card>
              ))}
            </div>
            <Pagination
              current={page}
              total={total}
              pageSize={limit}
              onChange={setPage}
              className={styles.pagination}
            />
          </>
        )}
      </Spin>

      <Modal
        title={action === 'approve' ? 'تایید مقاله' : 'رد کردن مقاله'}
        open={showModal}
        onOk={submitAction}
        onCancel={() => setShowModal(false)}
        okText={action === 'approve' ? 'تایید' : 'رد کردن'}
        cancelText="لغو"
      >
        {action === 'reject' && (
          <div>
            <p>توضیحات رد کردن (الزامی):</p>
            <Input.TextArea
              value={adminNotes}
              onChange={(e) => setAdminNotes(e.target.value)}
              rows={4}
              placeholder="دلیل رد کردن را وارد کنید"
            />
          </div>
        )}
        {action === 'approve' && (
          <div>
            <p>توضیحات اضافی (اختیاری):</p>
            <Input.TextArea
              value={adminNotes}
              onChange={(e) => setAdminNotes(e.target.value)}
              rows={3}
              placeholder="پیام برای نویسنده"
            />
          </div>
        )}
      </Modal>
    </div>
  );
}
